// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:31:18.834Z
// Property: Waterford Trails (ID: 6767906449162945)
// Collections: 44 amenities, 16 floorplans (live), 85 photos, 3 POIs, 8 reviews, 6 virtual tours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162945",
  "property_external_id": "4777979",
  "property_zillow_url": "https://www.zillow.com/homedetails/21201-Emerald-Mist-Pkwy-APT-217-Spring-TX-77379/2091046215_zpid/",
  "property_apartments_url": "https://www.apartments.com/1801-metrowest-orlando-fl/53dh5wn",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "waterford-trails",
  "property_name": "Waterford Trails",
  "property_website_url": "https://www.waterfordtrailsliving.com/",
  "property_domain": null,
  "property_address": "21201 Emerald Mist Pkwy",
  "property_full_address": "21201 Emerald Mist Pkwy",
  "property_address_1": "21201 Emerald Mist Pkwy",
  "property_address_2": null,
  "property_address_city": "Spring",
  "property_address_state": "TX",
  "property_address_zip_full": "77379-1535",
  "property_address_zip": "77379",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "MetroWest",
  "property_address_latitude": "28.5203475",
  "property_address_longitude": "-81.4575848",
  "property_email": "waterford@alapts.com",
  "property_phone": "(281) 251-8800",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your ideal living space at Waterford Trails in Spring, Texas! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, complemented by exceptional amenities like a fitness center and on-site maintenance. Find your new home today—browse our availability or schedule a tour to experience our vibrant community!",
  "property_long_description": "Welcome to Waterford Trails, your ideal apartment community nestled in the heart of Spring, Texas! Our diverse range of floor plans, including one-bedroom, two-bedroom, and three-bedroom apartments, caters to every lifestyle, whether you’re seeking a cozy retreat or a spacious family home. Each unit is thoughtfully designed to enhance your living experience, making Waterford Trails not just a place to live, but a true home.\n\nAt Waterford Trails, we prioritize convenience and comfort with an array of community amenities that serve your needs. Stay active in our fully-equipped fitness center, or enjoy the ease of having an elevator for effortless access to your new home. With a dedicated property manager and on-site maintenance team, you can rest assured that all your needs will be promptly addressed, allowing you to focus on what truly matters—enjoying your life!\n\nLocated in a vibrant neighborhood, Waterford Trails places you close to shopping centers, restaurants, and recreational facilities, ensuring you’re never far from the excitement of Spring, Texas. Our welcoming community atmosphere fosters connections and makes it easy to meet your neighbors, creating a friendly environment for everyone.\n\nReady to experience the comfort and convenience of Waterford Trails? Find your new home today! Browse our availability or schedule a tour to visit our community and see for yourself the perfect blend of style and functionality that awaits you. Your ideal apartment lifestyle is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-85da-7620-ba15-8875cb3dffca.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a granite-top island with bar stools.",
    "public_id": "019cfde0-85da-7620-ba15-8875cb3dffca",
    "storage_key": "property/6767906449162945/019cfde0-85da-7620-ba15-8875cb3dffca.webp",
    "width": 1240,
    "height": 828
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "340",
  "property_year_built": "1990",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.47058823529412",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-7b13-731c-b7ed-89dce5e30646.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfde0-7b13-731c-b7ed-89dce5e30646",
    "storage_key": "property/6767906449162945/019cfde0-7b13-731c-b7ed-89dce5e30646.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-7b13-731c-b7ed-89dce5e30646.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfde0-7b13-731c-b7ed-89dce5e30646",
    "storage_key": "property/6767906449162945/019cfde0-7b13-731c-b7ed-89dce5e30646.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "590 - 1409",
  "property_sqft_min": "590",
  "property_sqft_max": "1409",
  "property_price_range": "1181.33 - 2520.66",
  "property_price_min": "1181.33",
  "property_price_max": "2520.66",
  "property_available_units": 12,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Waterford Trails in Spring, Texas! With a selection of one, two, and three-bedroom floor plans, our community suits every lifestyle. Explore local favorites and uncover nearby attractions—your perfect Spring adventure awaits. See what's around our community today!",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "The City Beautiful earns its nickname, from its gorgeous lakes and bright, sunny skies to its pristine streets and beautiful architecture. Lake Eola Park, with its swan-shaped paddle boats and majestic fountain, provides an oasis in the city that's ideal for weekend picnics and afternoon lunch breaks. Located in the heart of Florida, the beaches of either coast (Gulf and Atlantic) are accessible in roughly an hour’s drive from Orlando.\n\t\t\t\t\tWhile it is known for being the home of prominent theme parks like Walt Disney World, Universal Studios, and Sea World, Orlando is also the county seat and home to one of the largest universities in the United States, the University of Central Florida. The city contains the Orange County Convention Center, the second-largest convention center in the country, in addition to the busy Orlando International Airport.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Orlando",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Discover your perfect home at Waterford Trails in Spring, Texas! Choose from spacious one, two, or three-bedroom floor plans, complemented by amenities like a fitness center, on-site maintenance, and convenient elevators. Explore our amazing community amenities and apartment features today—your ideal lifestyle awaits!",
  "property_applynow_blurb": "Discover your ideal living space at Waterford Trails in Spring, Texas! Choose from spacious one, two, and three-bedroom floor plans, all designed for comfort. Enjoy top-tier amenities, including a fitness center, on-site management, and maintenance services. Find your new home and lease online today! ",
  "property_contactus_blurb": "Discover your perfect home at Waterford Trails in Spring, Texas! Choose from our thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Have questions? Contact our leasing team today for more information and let us help you find your ideal apartment!",
  "property_faqs_blurb": "At Waterford Trails in Spring, Texas, we offer a variety of spacious floor plans, including one, two, and three-bedroom apartments. Explore our community and discover the perfect home for you. Have questions? Browse our FAQs page to find answers to all your inquiries about living at Waterford Trails!",
  "property_floorplans_blurb": "Discover your dream home at Waterford Trails in Spring, Texas! Choose from our spacious one, two, or three-bedroom floor plans designed for comfort and style. With modern amenities and a welcoming community, you’re sure to find the perfect fit. Browse our available apartment homes and explore your options today!",
  "property_gallery_blurb": "Discover your ideal living space at Waterford Trails in Spring, Texas! Choose from our modern one, two, or three-bedroom floor plans, complemented by exceptional amenities, including a fitness center, on-site property manager, and maintenance services. Picture yourself living here—explore our stunning photo gallery today!",
  "property_interactivemap_blurb": "Discover your ideal home at Waterford Trails in Spring, Texas! Choose from spacious one, two, or three-bedroom floor plans. Enjoy exceptional amenities like a fitness center, on-site property management, and maintenance services. Use our interactive community map to explore available apartments and find your perfect fit today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "Discover your perfect home at Waterford Trails in Spring, Texas! Choose from spacious one, two, and three-bedroom floor plans tailored for your lifestyle. Great friends make great neighbors—refer a friend to our vibrant community today and share the joy of living at Waterford Trails!",
  "property_residentaccess_blurb": "Welcome to Waterford Trails in Spring, Texas! Explore our thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Don’t forget to access your resident portal to easily pay rent, schedule maintenance, and enjoy all that our community has to offer! Your comfort is just a click away!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257818049",
  "property_scheduletour_blurb": "Discover your ideal home at Waterford Trails in Spring, Texas! Explore our thoughtfully designed one, two, and three-bedroom floor plans. Schedule a tour today and experience the vibrant community firsthand. Want to know more? See what our residents have to say about living at Waterford Trails!",
  "property_thankyou_blurb": "Thank you for submitting your information about Waterford Trails in Spring, Texas! With versatile floor plans featuring one, two, and three-bedroom apartments, we have the perfect space to suit your lifestyle. Stay tuned as a member of our team will reach out shortly to assist you further!",
  "property_virtualtours_blurb": "Experience the perfect blend of comfort and style at Waterford Trails in Spring, Texas. Choose from stunning one, two, and three-bedroom floor plans that cater to your lifestyle. Explore all our options and take a virtual tour of our community and inviting apartments for rent today! Don’t miss out!",
  "property_copyright": "2025 All Rights Reserved. Waterford Trails",
  "property_seo_title_home": "Waterford Trails | Apartments in Spring, Texas",
  "property_seo_description_home": "Discover your ideal living space at Waterford Trails in Spring, Texas! Explore our spacious one, two, and three-bedroom floor plans, all complemented by top-notch amenities like a fitness center, on-site management, and maintenance services. Enjoy the convenience of an elevator and a vibrant community atmosphere. Find your new home today at Waterford Trails!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Spring, Texas",
  "property_seo_description_floorplans": "Discover your ideal living space at Waterford Trails in Spring, Texas! Explore our diverse range of floor plans, including cozy one-bedroom, spacious two-bedroom, and family-friendly three-bedroom apartments. Browse our available apartment homes today and find the perfect floor plan that suits your lifestyle. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Spring, Texas Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant lifestyle at Waterford Trails in Spring, Texas! Explore our diverse floor plans, including one, two, and three-bedroom apartments, and experience top-notch amenities such as a fitness center, convenient elevators, on-site property management, and maintenance. Dive into luxury living—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Spring, Texas",
  "property_seo_description_gallery": "Discover the beauty of Waterford Trails in Spring, Texas! Explore our stunning photo gallery showcasing our one, two, and three-bedroom floor plans, coupled with exceptional amenities like a state-of-the-art fitness center, convenient on-site maintenance, and an attentive property manager. Picture yourself living here and experience the perfect blend of comfort and style—visit our gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | Waterford Trails Apartments",
  "property_seo_description_virtualtours": "Explore Waterford Trails in Spring, Texas, and discover your ideal home! Our diverse floor plans include one, two, and three-bedroom apartments designed for comfort and convenience. Ready to see more? Take a virtual tour of our beautiful community and apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Waterford Trails Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Waterford Trails in Spring, Texas! Explore our spacious one, two, and three-bedroom floor plans, and enjoy top-notch amenities including a fitness center, on-site property management, and maintenance support. Use our interactive community map to find available apartments, view pricing, and choose your perfect space today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Spring, Texas",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Waterford Trails in Spring, Texas! Explore our one, two, and three-bedroom apartment floor plans while uncovering local favorites and nearby points of interest. See what’s around our community and start your new adventure today!",
  "property_seo_title_contact": "Contact Us | Waterford Trails",
  "property_seo_description_contact": "Discover your perfect home at Waterford Trails in Spring, Texas! Explore our diverse floor plans including spacious one, two, and three-bedroom apartments designed for comfort and style. Have questions? Contact our friendly leasing team today to learn more about our vibrant community and find the ideal space for you!",
  "property_seo_title_faqs": "FAQs | Apartments in Spring, Texas",
  "property_seo_description_faqs": "Discover the answers to your questions at Waterford Trails in Spring, Texas! Our FAQs page covers everything from our spacious one, two, and three-bedroom floor plans to our fantastic amenities, including a state-of-the-art fitness center, on-site maintenance, and a dedicated property manager. Browse now to learn more about our vibrant community and how we can make your living experience exceptional!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Spring, Texas",
  "property_seo_description_reviews": "Discover the vibrant community at Waterford Trails in Spring, Texas! Explore our spacious one, two, and three-bedroom floor plans while enjoying top-notch amenities like a fitness center, on-site property management, elevators, and 24/7 maintenance. Curious about life at Waterford Trails? See what our residents have to say and find your perfect home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Spring, Texas",
  "property_seo_description_applynow": "Discover your perfect apartment at Waterford Trails in Spring, Texas! Choose from spacious one, two, or three-bedroom floor plans designed for your lifestyle. Enjoy exceptional amenities, including a state-of-the-art fitness center, convenient elevators, and on-site management and maintenance. Don’t wait—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Waterford Trails",
  "property_seo_description_residentaccess": "\"Welcome to Waterford Trails in Spring, Texas! Easily manage your living experience through our resident portal. Access your account to pay rent, schedule maintenance, and explore community features. Log in today for seamless convenience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Waterford Trails",
  "property_seo_description_referafriend": "\"Discover the vibrant lifestyle at Waterford Trails in Spring, Texas! Refer a friend and enjoy exclusive rewards. Great friends make great neighbors—invite someone to experience our welcoming community today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Waterford Trails",
  "property_seo_description_scheduletour": "Explore the serene charm of Waterford Trails in Spring, Texas! Schedule a tour of our inviting apartment community today and discover your new home, complete with modern amenities and scenic surroundings. Don’t miss out—book your visit now!",
  "property_seo_title_privacy": "Privacy Policy | Waterford Trails",
  "property_seo_description_privacy": "Discover the commitment to your privacy at Waterford Trails in Spring, Texas. Our Privacy Policy ensures your information is protected and handled with care. Learn more about our practices and your rights. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Waterford Trails",
  "property_seo_description_accessibility": "\"Explore Waterford Trails in Spring, Texas, where we prioritize digital inclusion for all. Our accessibility statement outlines our commitment to creating an inviting and inclusive environment. Discover how we support every resident's needs—learn more today!\"",
  "property_seo_title_sitemap": "Sitemap | Waterford Trails",
  "property_seo_description_sitemap": "Discover all that Waterford Trails in Spring, Texas has to offer with our comprehensive sitemap! Easily navigate through our charming apartment community, amenities, and services. View our website sitemap now and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Waterford Trails",
  "property_seo_description_thankyou": "Thank you for contacting Waterford Trails in Spring, Texas! We appreciate your interest. A member of our team will reach out shortly to assist you with your apartment search. Discover your future home in our vibrant community today!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1784583186949",
  "amenities": [
    {
      "id": "ec_208ba000843bdb4cbdac9bfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Community",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_017f99e635bbce03aa763d4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c652c10b29390e4e490927cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000602",
      "title": "Billiards",
      "amount": "0.0000",
      "description": "Billiards and Wine Room",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fef6f88881f7feb6f6ea5584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "WFH | Cyber Caf w/ PC and Mac",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f32b2364218d8732c97ebcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Modern Chef's Kitchen",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96dfee5931a96819ce8f8079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Clubhouse w/ Kitchen",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_641212f05c0dc19e9e7b713e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ada3919f3e8b5547c35382a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_850997bb8364bac365d7988b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Outdoor Pavilion w/ Fireplace",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08b7818f3cfa9b81cb54d0ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d34b60d8422958f2b7910f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Direct Access Garages*",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbb7c2d47e684164cbd95c8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Inspired Flooring",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fcf5fd48770f289d15fe362",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_011df4862dcb90df4a46a049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8830a4e7d64c664300a0ef52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Poolside Summer Kitchen",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07f9aa5bc0448a519630d337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_082f43142246eec4093589a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Resident Package System",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c922df69219c408a4021ab34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b158911baca5b0a8756e20c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b814bfd13fba2ebb98069230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a934a23723944b6a4c45709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Oversized Tubs",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52ffb999ceb870a70cb6c3ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cedbe09fa946d4f25a295d81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6952d3f3d83da75b44d76177",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Full-Size Walk-In Closets",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31739dbfac2b323f8b9d2e04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000045",
      "title": "Carpet",
      "amount": "0.0000",
      "description": "Carpet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dd9a3230bd12b855e78dcb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000079",
      "title": "USB Outlets",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14ebd6c528774c2122646f1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000094",
      "title": "Roman Soaking Tubs",
      "amount": "0.0000",
      "description": "Roman Soaking Tubs",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad4f1cf8cce2ed719882df89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000151",
      "title": "Handicap Accessible",
      "amount": "-50.0000",
      "description": "Handicap Accessible",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aade9b0e7cfebdd8fa29a9a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000179",
      "title": "Woodlands/Nature Trail",
      "amount": "50.0000",
      "description": "Woodlands/Nature Trail",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f429fd1471a1dba4e9837c47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000272",
      "title": "Upgraded",
      "amount": "0.0000",
      "description": "Upgraded",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8062b2d20e03e3f24b2934f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000276",
      "title": "2nd Floor",
      "amount": "25.0000",
      "description": "2nd Floor",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72f9e20633bd4cf542c5e030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000279",
      "title": "Fenced in Patio",
      "amount": "125.0000",
      "description": "Fenced in Patio",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35d2d8a1eb34ad21cc91b521",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000362",
      "title": "First Floor",
      "amount": "50.0000",
      "description": "First Floor",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef4ad6b5d6cbf46a39d750bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000372",
      "title": "Custom Master Closet Organizer",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0defab3ebff4b6a8eb4a4d1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "P000000411",
      "title": "9 ft. ceiling",
      "amount": "0.0000",
      "description": "9 ft. ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f89271fa331f12185c0fcf95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000112",
      "title": "Laminate (wood-look)",
      "amount": "0.0000",
      "description": "Laminate (wood-look)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af53c2f2e56ab2894a279a88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000166",
      "title": "Large walk-in closet",
      "amount": "0.0000",
      "description": "Large (40+ sq. ft.) walk-in closet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a2888176917153655cbe9a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000202",
      "title": "Full-size washer/dryer",
      "amount": "0.0000",
      "description": "Full-size washer dryer",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bf53c91ad9bb1f008127bfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000209",
      "title": "Large patio/balcony",
      "amount": "0.0000",
      "description": "Large Patio & Balcony (over 100 sq. ft)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5adee9b53f485e121425a3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000233",
      "title": "One car-direct-entry garage   ",
      "amount": "200.0000",
      "description": "One car-direct-entry garage",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3694867c8d2494711cd5aa6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000234",
      "title": "Two cars-direct-entry garage",
      "amount": "300.0000",
      "description": "Two cars-direct-entry garage",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c71a73b25d27fe6d4019cf23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000267",
      "title": "Stainless steel appliances",
      "amount": "0.0000",
      "description": "Stainless steel appliances",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0655e784e33bd1f75794d31a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000288",
      "title": "Lake view",
      "amount": "75.0000",
      "description": "Lake view",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_326d3fb4eec076fea0af6fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "realpage",
      "external_id": "S100000294",
      "title": "Pool view",
      "amount": "50.0000",
      "description": "Pool view",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_6b453842986be01e860034a5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-8c66-7444-aa6a-5064995dd134.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, two gray armchairs, a coffee table, dining table and chairs, and a kitchen counter with bar stools.",
        "public_id": "019cfddf-8c66-7444-aa6a-5064995dd134",
        "storage_key": "property/6767906449162945/019cfddf-8c66-7444-aa6a-5064995dd134.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish living room with modern furniture, including a blue sofa and gray armchairs, a coffee table, and a dining area adjacent to a sleek kitchen.",
      "link": "false",
      "alt_text": "Living room with a blue sofa, two gray armchairs, a coffee table, dining table and chairs, and a kitchen counter with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/e7QZpmQtptAZ64SI9BIbX_tKex_js38pULoluJJ1C2o/118/image.jpg"
    },
    {
      "id": "ec_55a68b63988ae50b30418ab3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-2411-765c-acfb-d5d37d25ec1c.webp",
      "image_media": {
        "alt_text": "Modern leasing office and reception area with contemporary decor and a fitness room visible through glass doors.",
        "public_id": "019d4e8c-2411-765c-acfb-d5d37d25ec1c",
        "storage_key": "property/6767906449162945/019d4e8c-2411-765c-acfb-d5d37d25ec1c.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Community",
      "description": "Welcome to our vibrant leasing office, featuring a modern reception area and a state-of-the-art fitness room. Experience comfort and style.",
      "link": "false",
      "alt_text": "Modern leasing office and reception area with contemporary decor and a fitness room visible through glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BI91SXryjvy2zJEgsvZ5s8tH067hdyGWept0VZjBzbg/102/image.jpg"
    },
    {
      "id": "ec_aa163b5f28ce3234d8903735",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-3fcd-7564-80c1-8c9f6d52f4b4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d4e8c-3fcd-7564-80c1-8c9f6d52f4b4",
        "storage_key": "property/6767906449162945/019d4e8c-3fcd-7564-80c1-8c9f6d52f4b4.webp",
        "width": 1659,
        "height": 1106
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the sparkling outdoor pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MqPnZqsvfTliz-0EbBAB8BZuvJSldBCuVU6YVshVq4E/102/image.jpg"
    },
    {
      "id": "ec_88d9262eb465a67636b3b276",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6f02-70e7-9d5b-ca2f6d9268f5.webp",
      "image_media": {
        "alt_text": "Modern living room and dining area with blue sofa, grey armchair, and bar seating.",
        "public_id": "019cfde0-6f02-70e7-9d5b-ca2f6d9268f5",
        "storage_key": "property/6767906449162945/019cfde0-6f02-70e7-9d5b-ca2f6d9268f5.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Stylish and spacious living area seamlessly transitioning into a dining space with bar seating. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Modern living room and dining area with blue sofa, grey armchair, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sEnFxTLfJ-uj8oB7hFOngWwyV_uwAEnHh0J6VJR8Gyk/111/image.jpg"
    },
    {
      "id": "ec_bd553737d882b0a8eaae7fe1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6ee8-7782-b0f8-e49f37c51346.webp",
      "image_media": {
        "alt_text": "Spacious apartment complex lobby with a reception desk, lounge seating, and gym equipment visible through glass doors.",
        "public_id": "019cfde0-6ee8-7782-b0f8-e49f37c51346",
        "storage_key": "property/6767906449162945/019cfde0-6ee8-7782-b0f8-e49f37c51346.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Welcome to our modern apartment lobby, featuring a stylish reception area, comfortable seating, and a well-equipped fitness center, all designed for resident convenience and enjoyment.",
      "link": "false",
      "alt_text": "Spacious apartment complex lobby with a reception desk, lounge seating, and gym equipment visible through glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ahl9kwtY2iScOJYzO6_kdEW4PJJu4b15zukT8gP0tw0/110/image.jpg"
    },
    {
      "id": "ec_16eb584d56fbeff638d167a4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6e8e-72eb-9553-3f655c801d3d.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, dumbbells, medicine balls, and exercise bikes.",
        "public_id": "019cfde0-6e8e-72eb-9553-3f655c801d3d",
        "storage_key": "property/6767906449162945/019cfde0-6e8e-72eb-9553-3f655c801d3d.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and functional training equipment.",
      "link": "false",
      "alt_text": "Gym with treadmills, dumbbells, medicine balls, and exercise bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/9QHYqhFq3c5F242izHwORBQ-Ph1pSdLAENFD71Ti6M8/111/image.jpg"
    },
    {
      "id": "ec_cbd919140f8e66ae3ddf943d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6e55-761f-8ae6-d49ad34e03e6.webp",
      "image_media": {
        "alt_text": "Spacious living room with vaulted ceilings, fireplace, and view of kitchen.",
        "public_id": "019cfde0-6e55-761f-8ae6-d49ad34e03e6",
        "storage_key": "property/6767906449162945/019cfde0-6e55-761f-8ae6-d49ad34e03e6.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious apartment featuring vaulted ceilings, a cozy fireplace, and a modern kitchen.",
      "link": "false",
      "alt_text": "Spacious living room with vaulted ceilings, fireplace, and view of kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zi_J50lkt1LBGw12mtRdT75RzUVBl920Lofc6RFzfkw/110/image.jpg"
    },
    {
      "id": "ec_87ed5106ebd2d27ab6da9035",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-3fcd-7564-80c1-8c9f6d52f4b4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d4e8c-3fcd-7564-80c1-8c9f6d52f4b4",
        "storage_key": "property/6767906449162945/019d4e8c-3fcd-7564-80c1-8c9f6d52f4b4.webp",
        "width": 1659,
        "height": 1106
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the sparkling outdoor pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MqPnZqsvfTliz-0EbBAB8BZuvJSldBCuVU6YVshVq4E/102/image.jpg"
    },
    {
      "id": "ec_7f9038d6178ab42a97ef2983",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-2d0e-703a-bc9e-f97ef55b24b7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a laundry closet.",
        "public_id": "019d4e8c-2d0e-703a-bc9e-f97ef55b24b7",
        "storage_key": "property/6767906449162945/019d4e8c-2d0e-703a-bc9e-f97ef55b24b7.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this fully equipped modern kitchen, featuring sleek white cabinetry, elegant granite countertops, and stainless steel appliances. Includes a convenient laundry closet.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a laundry closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/06qSdrjce9m5HWMmKlZhMNf4iN-1uKNy41RD40e0kwk/102/image.jpg"
    },
    {
      "id": "ec_83925c2e85237a496f9c1f00",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-9981-776f-9f9c-e022a51bff24.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, rowing machines, weight machines, and free weights.",
        "public_id": "019cfddf-9981-776f-9f9c-e022a51bff24",
        "storage_key": "property/6767906449162945/019cfddf-9981-776f-9f9c-e022a51bff24.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center. Featuring state-of-the-art cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, rowing machines, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SBo7lbcElBkKpZ0yIOFWpSYJNEYb-sl1AjlNGCJeers/118/image.jpg"
    },
    {
      "id": "ec_a25f1e48c2b66ff0058e2283",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-9c16-7671-9c99-f47d1046d0b8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019cfddf-9c16-7671-9c99-f47d1046d0b8",
        "storage_key": "property/6767906449162945/019cfddf-9c16-7671-9c99-f47d1046d0b8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable queen-size bed with plush bedding, a modern dresser, and a chic nightstand with a desk lamp.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/v1fezbECLFwEeRyLSyNHrA8DU_frOOq8UgDkz-G-yuI/102/image.jpg"
    },
    {
      "id": "ec_f68e4d0a5774d1ea052f0dd8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-a2e9-7258-88d9-79476ba04554.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with grill stations, seating, and a pool in the background.",
        "public_id": "019cfddf-a2e9-7258-88d9-79476ba04554",
        "storage_key": "property/6767906449162945/019cfddf-a2e9-7258-88d9-79476ba04554.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Enjoy outdoor living with built-in grills, comfortable seating, and a sparkling pool. Perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Outdoor covered patio with grill stations, seating, and a pool in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BFcUHiz4_u99pUHsSOKjC0PzFBvW_l_XPZ7sdmb991A/117/image.jpg"
    },
    {
      "id": "ec_e23573e46ed2a6aafe610511",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-a472-71a5-8ccf-3e8a92641ec0.webp",
      "image_media": {
        "alt_text": "Dining table set for four with wine glasses, plates, and cutlery, adjacent to a modern kitchen and living area.",
        "public_id": "019cfddf-a472-71a5-8ccf-3e8a92641ec0",
        "storage_key": "property/6767906449162945/019cfddf-a472-71a5-8ccf-3e8a92641ec0.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this beautifully appointed apartment, featuring a spacious living area and a modern, fully equipped kitchen.",
      "link": "false",
      "alt_text": "Dining table set for four with wine glasses, plates, and cutlery, adjacent to a modern kitchen and living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/09ELVr0h4sup4XbcmsyNoId21Fmc358bkAozfdRUg9g/102/image.jpg"
    },
    {
      "id": "ec_30057747a3ce372bbfc30f89",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-a2cb-7098-8230-52aae539f3a9.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment complex lounge area with plush seating, a coffee bar, and dining tables.",
        "public_id": "019cfddf-a2cb-7098-8230-52aae539f3a9",
        "storage_key": "property/6767906449162945/019cfddf-a2cb-7098-8230-52aae539f3a9.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a convenient coffee bar, and ample space for work or socializing.",
      "link": "false",
      "alt_text": "Interior of a modern apartment complex lounge area with plush seating, a coffee bar, and dining tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/W5aHkKMe5mkW_QhptE_TH6CENbN_xiLZftkbW5PgSsw/119/image.jpg"
    },
    {
      "id": "ec_de4ada7b78770bb918e2347f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-a830-734f-bbc5-965fd5aaf413.webp",
      "image_media": {
        "alt_text": "Stylish living room with blue sofa, grey armchairs, coffee table, and TV.",
        "public_id": "019cfddf-a830-734f-bbc5-965fd5aaf413",
        "storage_key": "property/6767906449162945/019cfddf-a830-734f-bbc5-965fd5aaf413.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed apartment featuring a spacious living area with comfortable seating, a sleek coffee table, and entertainment center.",
      "link": "false",
      "alt_text": "Stylish living room with blue sofa, grey armchairs, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3QfTsxU2cMQbUqOeVu9sG-_CKsuPfVFDj5dBsE_jQ3g/102/image.jpg"
    },
    {
      "id": "ec_3aa41028e1812409101c7fed",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-aef5-74de-b77f-ecade0c57467.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with manicured landscaping and tiered garden beds.",
        "public_id": "019cfddf-aef5-74de-b77f-ecade0c57467",
        "storage_key": "property/6767906449162945/019cfddf-aef5-74de-b77f-ecade0c57467.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community, featuring well-maintained exteriors and beautiful landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with manicured landscaping and tiered garden beds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LTA7J65WKK_vnTSKZH2mR_zxgwR2-pCi7q0mlFwIoPY/118/image.jpg"
    },
    {
      "id": "ec_069c774ce66e7e59004df434",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ad63-71ea-b55b-0264425b5bc6.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with various exercise machines and free weights.",
        "public_id": "019cfddf-ad63-71ea-b55b-0264425b5bc6",
        "storage_key": "property/6767906449162945/019cfddf-ad63-71ea-b55b-0264425b5bc6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Well-equipped gym with various exercise machines and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3nGgp0leT3xOzsbVghvcjIxAgWsPEkvtSrtexfvVP_w/102/image.jpg"
    },
    {
      "id": "ec_bcc0ecf87753d12fa3cfc685",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ae87-7557-9337-e7693406ca09.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and a coffee bar.",
        "public_id": "019cfddf-ae87-7557-9337-e7693406ca09",
        "storage_key": "property/6767906449162945/019cfddf-ae87-7557-9337-e7693406ca09.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed community lounge, complete with a convenient coffee bar.",
      "link": "false",
      "alt_text": "Modern lounge area with comfortable seating and a coffee bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3H1Png3S11Ik8uHLzpT8gt42hq6NZMs9AiZHNO2rvR8/118/image.jpg"
    },
    {
      "id": "ec_75d6b9f9efafb3bfe71d97ba",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-0605-72ed-b5d3-8d5a6dba595e.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with bar stools, stainless steel appliances, and abstract wall art.",
        "public_id": "019d20a9-0605-72ed-b5d3-8d5a6dba595e",
        "storage_key": "property/6767906449162945/019d20a9-0605-72ed-b5d3-8d5a6dba595e.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed kitchen and dining area, featuring modern appliances, a breakfast bar, and stylish decor.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with bar stools, stainless steel appliances, and abstract wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1jFPdef-DNAElUvZU4DfJfmWvfIF5dzR97HxSxMFmTc/102/image.jpg"
    },
    {
      "id": "ec_bc5f2bb550b9f72f09fcb303",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-b68c-713f-a4e3-95b2892ca40f.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with chairs and a table next to a swimming pool.",
        "public_id": "019cfddf-b68c-713f-a4e3-95b2892ca40f",
        "storage_key": "property/6767906449162945/019cfddf-b68c-713f-a4e3-95b2892ca40f.webp",
        "width": 1681,
        "height": 1121
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor seating area, perfectly situated beside the sparkling swimming pool. Enjoy the beautiful surroundings and soak up the sun.",
      "link": "false",
      "alt_text": "Outdoor seating area with chairs and a table next to a swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cL-ZKva-39T_JD10paKxS5n7aZcBYkA8mZilsAlMKwo/118/image.jpg"
    },
    {
      "id": "ec_8fa82f8cd51122667f1b8202",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-5427-70a8-85ee-e83a48503a18.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
        "public_id": "019d4e8c-5427-70a8-85ee-e83a48503a18",
        "storage_key": "property/6767906449162945/019d4e8c-5427-70a8-85ee-e83a48503a18.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Explore this stylish kitchen featuring sleek stainless steel appliances, beautiful granite countertops, and ample white cabinetry, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/geWH72STCKibH_m-HvzqrKMOWokxLiQ1auUFTExpwCY/102/image.jpg"
    },
    {
      "id": "ec_654a2b7c5862c9cf23df946d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ba20-716e-9111-ace6abc2d917.webp",
      "image_media": {
        "alt_text": "Modern leasing office lobby with reception desk and seating area.",
        "public_id": "019cfddf-ba20-716e-9111-ace6abc2d917",
        "storage_key": "property/6767906449162945/019cfddf-ba20-716e-9111-ace6abc2d917.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to our vibrant leasing office, featuring a modern reception desk, comfortable seating, and elegant decor. Experience our community's welcoming atmosphere.",
      "link": "false",
      "alt_text": "Modern leasing office lobby with reception desk and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/g87jJCiDyZrIu7Afkc2bY5LyGfsKEXxel87hwfDiZ4E/119/image.jpg"
    },
    {
      "id": "ec_ff5403e3b2025058f18b07f2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-62dc-7770-9ce1-266775c9b4eb.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, dresser, and access to a closet and bathroom.",
        "public_id": "019d4e8c-62dc-7770-9ce1-266775c9b4eb",
        "storage_key": "property/6767906449162945/019d4e8c-62dc-7770-9ce1-266775c9b4eb.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed and ample storage. Enjoy easy access to a modern bathroom and a spacious walk-in closet.",
      "link": "false",
      "alt_text": "Stylish bedroom with a king-size bed, dresser, and access to a closet and bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tCtjpNOC5DxnFXMvGnWU48GEDJKGI8v8kxtofuCynIc/102/image.jpg"
    },
    {
      "id": "ec_5bc171801f12cfac0058812e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-c057-761c-9c94-16d303ab310f.webp",
      "image_media": {
        "alt_text": "Metro West Premier Apartments monument sign and entrance.",
        "public_id": "019cfddf-c057-761c-9c94-16d303ab310f",
        "storage_key": "property/6767906449162945/019cfddf-c057-761c-9c94-16d303ab310f.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "The monument sign for Metro West Premier Apartments welcomes visitors to the community. The entrance features the leasing office and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Metro West Premier Apartments monument sign and entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DLE_ta8beDvz5rasUUiXZ-hQ8Wi36YLHJlSBrGpazUg/118/image.jpg"
    },
    {
      "id": "ec_55656cf9459a020a18773933",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-c06e-72cb-b179-5dc23c962965.webp",
      "image_media": {
        "alt_text": "Bathroom with white tub, toilet, and vanity with a white sink.",
        "public_id": "019cfddf-c06e-72cb-b179-5dc23c962965",
        "storage_key": "property/6767906449162945/019cfddf-c06e-72cb-b179-5dc23c962965.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a deep soaking tub, a modern vanity with a clean white sink, and a contrasting navy blue accent wall.",
      "link": "false",
      "alt_text": "Bathroom with white tub, toilet, and vanity with a white sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_GzFViK90paxiUByJ477xwaJ2Eqe1P3PlufSaEGssfg/102/image.jpg"
    },
    {
      "id": "ec_766b41b51e3ebb06b0c70509",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-c40c-720d-9df6-c4c609c6bf84.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019cfddf-c40c-720d-9df6-c4c609c6bf84",
        "storage_key": "property/6767906449162945/019cfddf-c40c-720d-9df6-c4c609c6bf84.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and umbrellas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/x3ZUzKpBUX5F2D07hn1JJCARPLQVo2arbL7MqXLiFDo/118/image.jpg"
    },
    {
      "id": "ec_b7fadc3c0298fb7ecd476596",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-c4f6-7377-bb17-4a11a0c358a0.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with treadmills, elliptical, weight machines, and free weights.",
        "public_id": "019cfddf-c4f6-7377-bb17-4a11a0c358a0",
        "storage_key": "property/6767906449162945/019cfddf-c4f6-7377-bb17-4a11a0c358a0.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide selection of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Fully equipped fitness center with treadmills, elliptical, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gM2HEnmnRdyzrykql1_FqWMna0PjX7m02T1VwPdjHh0/102/image.jpg"
    },
    {
      "id": "ec_563f384ed4147975a7aecebb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ca1c-7378-9a5f-552446dfdb4e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and dining area",
        "public_id": "019cfddf-ca1c-7378-9a5f-552446dfdb4e",
        "storage_key": "property/6767906449162945/019cfddf-ca1c-7378-9a5f-552446dfdb4e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "View of a stylish apartment kitchen, complete with a granite island, bar stools, and adjacent dining area with a table and chairs.",
      "link": "false",
      "alt_text": "Modern kitchen with island and dining area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/aMgYKdKfjG9rPghzHXG-fDiStvWWIywepvJRGfnB7DQ/118/image.jpg"
    },
    {
      "id": "ec_f3c38b95deb152c352e2cdcb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ca59-7713-94f9-87e22d23261d.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with blue sofas, a coffee table, and teal umbrellas.",
        "public_id": "019cfddf-ca59-7713-94f9-87e22d23261d",
        "storage_key": "property/6767906449162945/019cfddf-ca59-7713-94f9-87e22d23261d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, featuring comfortable seating and shaded umbrellas perfect for enjoying the beautiful weather.",
      "link": "false",
      "alt_text": "Outdoor lounge area with blue sofas, a coffee table, and teal umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k_s9KbCbEi5dl2CEqrlljRyNRNKdoiUU6bxQ6OBbFW0/119/image.jpg"
    },
    {
      "id": "ec_3c9d68dbdc7ab1fdbaf5d230",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ce64-71f8-b7dc-63dd427d3bc9.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, gray armchairs, modern decor, and wood-look flooring.",
        "public_id": "019cfddf-ce64-71f8-b7dc-63dd427d3bc9",
        "storage_key": "property/6767906449162945/019cfddf-ce64-71f8-b7dc-63dd427d3bc9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a vibrant blue sofa, plush gray armchairs, and contemporary decorative elements, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with blue sofa, gray armchairs, modern decor, and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/IIXaXwbSGB9nsc0I_RysVlNSsM3UtRD5ZFqQZy3rLXg/118/image.jpg"
    },
    {
      "id": "ec_cbcfa7bae158a4e9fec5b210",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-cf20-7548-8023-577570018dcc.webp",
      "image_media": {
        "alt_text": "Tennis and pickleball courts with apartment buildings in the background",
        "public_id": "019cfddf-cf20-7548-8023-577570018dcc",
        "storage_key": "property/6767906449162945/019cfddf-cf20-7548-8023-577570018dcc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our on-site tennis and pickleball courts, perfect for friendly matches and staying fit.",
      "link": "false",
      "alt_text": "Tennis and pickleball courts with apartment buildings in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gEmRDB7Npoc4M7sd9E616xigczeZyzVZbeFhrQR4KTk/119/image.jpg"
    },
    {
      "id": "ec_3a5135a3be43abdf88820517",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-d0e6-748f-ace5-a8fb114ad71e.webp",
      "image_media": {
        "alt_text": "King size bed with blue and white bedding and pillows, navy accent wall, dresser, and chair.",
        "public_id": "019cfddf-d0e6-748f-ace5-a8fb114ad71e",
        "storage_key": "property/6767906449162945/019cfddf-d0e6-748f-ace5-a8fb114ad71e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a king size bed with blue and white bedding, a navy accent wall with artwork, a dark wood dresser, and a comfortable accent chair.",
      "link": "false",
      "alt_text": "King size bed with blue and white bedding and pillows, navy accent wall, dresser, and chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Y8Ae9myMKGrZtjyAsL0NWxFAgQUeL0dLnI0wytotpos/117/image.jpg"
    },
    {
      "id": "ec_4b5286ca8626b56517225c6f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-d9e0-7498-a647-a66387f49c54.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs under a large blue umbrella.",
        "public_id": "019cfddf-d9e0-7498-a647-a66387f49c54",
        "storage_key": "property/6767906449162945/019cfddf-d9e0-7498-a647-a66387f49c54.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy relaxing or dining al fresco in our inviting outdoor seating area, perfect for enjoying the beautiful weather.",
      "link": "false",
      "alt_text": "Outdoor seating area with tables and chairs under a large blue umbrella.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rmLrvSW1hlZ2gYWqS-8YwnOmyqr_FSE4t-mOrDG_VWk/119/image.jpg"
    },
    {
      "id": "ec_f4983be8f604987b15579439",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-0fe7-7185-be5b-b85be06176ca.webp",
      "image_media": {
        "alt_text": "Modern resident lounge area with tables, chairs, and a couch, featuring a television displaying \"Metrowest\" logo.",
        "public_id": "019d20a9-0fe7-7185-be5b-b85be06176ca",
        "storage_key": "property/6767906449162945/019d20a9-0fe7-7185-be5b-b85be06176ca.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish resident lounge. This inviting space features comfortable seating, dining areas, and entertainment options for you to enjoy.",
      "link": "false",
      "alt_text": "Modern resident lounge area with tables, chairs, and a couch, featuring a television displaying \"Metrowest\" logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cN5KSsI_ArdwqTgvjY7sfjNJ64l7kc9jMBY_GPYcr2Q/117/image.jpg"
    },
    {
      "id": "ec_653da76d635d5f6720789674",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-d906-74aa-9744-34e5bb5dee6a.webp",
      "image_media": {
        "alt_text": "Interior of a fitness center with exercise balls, medicine balls, and stationary bikes.",
        "public_id": "019cfddf-d906-74aa-9744-34e5bb5dee6a",
        "storage_key": "property/6767906449162945/019cfddf-d906-74aa-9744-34e5bb5dee6a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and free weights.",
      "link": "false",
      "alt_text": "Interior of a fitness center with exercise balls, medicine balls, and stationary bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HYbgheOMuerB__SEBW12HT4ta5UXQSio9z4EtRYnTqQ/112/image.jpg"
    },
    {
      "id": "ec_828712659cfd08d9abca1b13",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-dacf-7015-bcf0-6b9e8a092a84.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a grassy lawn in the foreground.",
        "public_id": "019cfddf-dacf-7015-bcf0-6b9e8a092a84",
        "storage_key": "property/6767906449162945/019cfddf-dacf-7015-bcf0-6b9e8a092a84.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "An exterior view of apartment buildings with manicured lawns and lush greenery, showcasing the property's serene community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a grassy lawn in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/AsbGurWObRpZUCjTi_YRsS20nE6OZzMaKYxUcLHdAdw/117/image.jpg"
    },
    {
      "id": "ec_3054abf6c4a423a5da1e72e1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-76ed-70da-bb15-48c78d751248.webp",
      "image_media": {
        "alt_text": "View of a bathroom with a closet on the left.",
        "public_id": "019d4e8c-76ed-70da-bb15-48c78d751248",
        "storage_key": "property/6767906449162945/019d4e8c-76ed-70da-bb15-48c78d751248.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "This spacious bathroom features a modern vanity, toilet, and a walk-in closet, offering ample storage.",
      "link": "false",
      "alt_text": "View of a bathroom with a closet on the left.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DTGQBZyRzw6xiPo5j5ZToYFvxUkHEhfH7JwmjF6bfME/102/image.jpg"
    },
    {
      "id": "ec_c2d036d2d789c0e2e6c79b86",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-dfe8-7158-a40c-fba3790a3c62.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019cfddf-dfe8-7158-a40c-fba3790a3c62",
        "storage_key": "property/6767906449162945/019cfddf-dfe8-7158-a40c-fba3790a3c62.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZBXpVWRoJhz5WvNrM_v0jo-W-jwe023QLp7WWADo_Nw/117/image.jpg"
    },
    {
      "id": "ec_991e7dd23c1ed7754d8c8ffc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-e31f-712f-85f1-c7f67c8713b0.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and landscaping",
        "public_id": "019cfddf-e31f-712f-85f1-c7f67c8713b0",
        "storage_key": "property/6767906449162945/019cfddf-e31f-712f-85f1-c7f67c8713b0.webp",
        "width": 640,
        "height": 560
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and landscaping",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6SnHBgdmcb6IEv9-icfN0nUtvLdwVHQxmfr-tP7qOoQ/102/image.jpg"
    },
    {
      "id": "ec_7afc0a6c7add2af940dc50df",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-c2ff-73dc-8042-e86ec90ad538.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and dining area.",
        "public_id": "019d4e8c-c2ff-73dc-8042-e86ec90ad538",
        "storage_key": "property/6767906449162945/019d4e8c-c2ff-73dc-8042-e86ec90ad538.webp",
        "width": 1280,
        "height": 370
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable seating. Perfect for a summer's day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1DDGUTsKz6gH6DTbuj0tuRjw_r2U0gltrMphtDYchrU/102/image.jpg"
    },
    {
      "id": "ec_05e5447512a57e64f218e17b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-867a-75d6-9ee8-2890ee8a14d2.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "019d4e8c-867a-75d6-9ee8-2890ee8a14d2",
        "storage_key": "property/6767906449162945/019d4e8c-867a-75d6-9ee8-2890ee8a14d2.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area in an apartment. Features a comfortable sofa, coffee table, and a modern kitchen with bar seating.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_qmsZLnJg8Tvs50_9JeF_BgSaMxBEDwKkIna90VWT6E/102/image.jpg"
    },
    {
      "id": "ec_8d415b7e10c09f84019d5c6c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-eac9-77e7-97d4-484aa974830f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with manicured landscaping and a paved walkway.",
        "public_id": "019cfddf-eac9-77e7-97d4-484aa974830f",
        "storage_key": "property/6767906449162945/019cfddf-eac9-77e7-97d4-484aa974830f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds surround this apartment building, featuring lush greenery and a winding walkway leading to the entrance.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with manicured landscaping and a paved walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UyXr6pNMikVVvKByZXCxLWuVvqUWweKRhKHJCiIJ5Ck/118/image.jpg"
    },
    {
      "id": "ec_6fb0bda64f46685d3bc8de60",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-eab4-706c-babe-8f8b24e215bd.webp",
      "image_media": {
        "alt_text": "Metrowest Premier Apartments entrance sign with American flag.",
        "public_id": "019cfddf-eab4-706c-babe-8f8b24e215bd",
        "storage_key": "property/6767906449162945/019cfddf-eab4-706c-babe-8f8b24e215bd.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Welcome to Metrowest Premier Apartments, where you can find your perfect home. Our community offers a variety of amenities and apartment styles to suit your needs.",
      "link": "false",
      "alt_text": "Metrowest Premier Apartments entrance sign with American flag.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RzYSlRPTNFIhHaJWza8tlyYFLwFcwjXww3zC6Yx0A1A/119/image.jpg"
    },
    {
      "id": "ec_93582ca9fe5bccd386c8400d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-eaa7-756b-a390-8302d358afc1.webp",
      "image_media": {
        "alt_text": "Exterior view of community building with parking lot and golf carts.",
        "public_id": "019cfddf-eaa7-756b-a390-8302d358afc1",
        "storage_key": "property/6767906449162945/019cfddf-eaa7-756b-a390-8302d358afc1.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "This image showcases the exterior of the community building, featuring a well-maintained parking lot with golf carts and a car, surrounded by lush trees and landscaping.",
      "link": "false",
      "alt_text": "Exterior view of community building with parking lot and golf carts.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/d8qX2M-8Uoe0liNxM1N_TbG_BSxZ-vxV7bm7g085WPc/118/image.jpg"
    },
    {
      "id": "ec_350b2c84a30252301f5b6409",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ecc4-776b-9b1b-050472be5d08.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and landscaping.",
        "public_id": "019cfddf-ecc4-776b-9b1b-050472be5d08",
        "storage_key": "property/6767906449162945/019cfddf-ecc4-776b-9b1b-050472be5d08.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with walkways and lush landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with walkways and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SLSGQsfQsADRVTV0uUMSuHUOhBUzuJ4k9Yf-CQPrYIg/119/image.jpg"
    },
    {
      "id": "ec_ab3f30a53b4d9f63f70e9fee",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-f4f5-720d-b97e-73f70b936a22.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with lush landscaping and blue sky.",
        "public_id": "019cfddf-f4f5-720d-b97e-73f70b936a22",
        "storage_key": "property/6767906449162945/019cfddf-f4f5-720d-b97e-73f70b936a22.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Charming exterior of the apartment building, featuring beautiful landscaping and a clear blue sky, creating a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with lush landscaping and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qbYzuUWB9u3rYPOAYhGuTOCwH3-hNYu_8jT2q9dOBE4/118/image.jpg"
    },
    {
      "id": "ec_2e8b3406a65f2e2c07cc6d42",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-f51e-712f-adcf-c6f35e661318.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stairs and palm trees.",
        "public_id": "019cfddf-f51e-712f-adcf-c6f35e661318",
        "storage_key": "property/6767906449162945/019cfddf-f51e-712f-adcf-c6f35e661318.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the exterior of an apartment building, featuring outdoor staircases and lush tropical landscaping with palm trees.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with stairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/o2hPaaBtWNlO78vUFbXVOOm-HSJZXjtssaD_dhuHbnI/119/image.jpg"
    },
    {
      "id": "ec_3d036780494f104580fbf40c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-1a5b-77db-a909-b11ed2d52d86.webp",
      "image_media": {
        "alt_text": "Modern leasing office reception desk with contemporary seating and decor.",
        "public_id": "019d20a9-1a5b-77db-a909-b11ed2d52d86",
        "storage_key": "property/6767906449162945/019d20a9-1a5b-77db-a909-b11ed2d52d86.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, featuring a stylish reception desk, comfortable seating areas, and elegant decor. Experience our inviting community atmosphere.",
      "link": "false",
      "alt_text": "Modern leasing office reception desk with contemporary seating and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7ec7aAgZ6__eXkIQ6U8lGRe7iNcdJmQR3-gNOkKdv0A/119/image.jpg"
    },
    {
      "id": "ec_d2a9cada973d3e0c9d5c4d51",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-f6d3-746c-b2c4-583d27014b79.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with modern furniture, coffee station, and high ceilings.",
        "public_id": "019cfddf-f6d3-746c-b2c4-583d27014b79",
        "storage_key": "property/6767906449162945/019cfddf-f6d3-746c-b2c4-583d27014b79.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring comfortable seating and a convenient coffee bar.",
      "link": "false",
      "alt_text": "Stylish lounge area with modern furniture, coffee station, and high ceilings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tOrJ-QXnV6R6GAUQZUY5pNRcvRb8smfkFkbE1S9b5aI/116/image.jpg"
    },
    {
      "id": "ec_e57678f41d23f218c66c03a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ff09-732e-a229-d6fa852a84a6.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with seating, tables, and a TV displaying the MetroWest logo.",
        "public_id": "019cfddf-ff09-732e-a229-d6fa852a84a6",
        "storage_key": "property/6767906449162945/019cfddf-ff09-732e-a229-d6fa852a84a6.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge. Features comfortable seating, work tables, and entertainment.",
      "link": "false",
      "alt_text": "Stylish lounge area with seating, tables, and a TV displaying the MetroWest logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5q5GmdbAaI4hQj4wLrxpIFLVDSN7ZD0QOQlpZpNUGeI/119/image.jpg"
    },
    {
      "id": "ec_8e0e53470fd6f4ebce09363e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-ff1c-776c-9dbc-2b702b713b6e.webp",
      "image_media": {
        "alt_text": "Fitness center with free weights, weight machines, cardio equipment, and yoga balls.",
        "public_id": "019cfddf-ff1c-776c-9dbc-2b702b713b6e",
        "storage_key": "property/6767906449162945/019cfddf-ff1c-776c-9dbc-2b702b713b6e.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and weight training equipment.",
      "link": "false",
      "alt_text": "Fitness center with free weights, weight machines, cardio equipment, and yoga balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/bvvLMyfGqZMQtxgEZ2rv2PRl5umgkTObBrQXJwBCqmo/116/image.jpg"
    },
    {
      "id": "ec_7ba662ab1a4e3f75c0872e0a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-004c-7215-a07b-8dbfe62aaa1e.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, cardio equipment, and free weights.",
        "public_id": "019cfde0-004c-7215-a07b-8dbfe62aaa1e",
        "storage_key": "property/6767906449162945/019cfde0-004c-7215-a07b-8dbfe62aaa1e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Gym with weight machines, cardio equipment, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jjNdp84wItLeFwQmYqOB63gcwB6pe0Q8h-7-Twzvw6o/119/image.jpg"
    },
    {
      "id": "ec_50c5fc130fc0c9a819d22d1b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-0125-768a-9389-41575d799746.webp",
      "image_media": {
        "alt_text": "Gym equipment including treadmills, elliptical, rowing machine, and weight machines.",
        "public_id": "019cfde0-0125-768a-9389-41575d799746",
        "storage_key": "property/6767906449162945/019cfde0-0125-768a-9389-41575d799746.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio and strength training equipment for residents.",
      "link": "false",
      "alt_text": "Gym equipment including treadmills, elliptical, rowing machine, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7I8jeJx8bHzeimPSgKALZh-bqYZxwubt7pJ12-MPDBQ/116/image.jpg"
    },
    {
      "id": "ec_84d9e6d5694693ac1b8e116a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-202b-7138-9ee1-075651302474.webp",
      "image_media": {
        "alt_text": "Package lockers and seating area in apartment building lobby.",
        "public_id": "019d20a9-202b-7138-9ee1-075651302474",
        "storage_key": "property/6767906449162945/019d20a9-202b-7138-9ee1-075651302474.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Secure package lockers and comfortable seating in the apartment building's common area, offering convenience for residents.",
      "link": "false",
      "alt_text": "Package lockers and seating area in apartment building lobby.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sPzqIsZQUxNvx1dQJwntq7EExdKQbzX8k1Bt593ykvU/119/image.jpg"
    },
    {
      "id": "ec_93341b8ff70c4188244898ff",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-08cb-7197-8daf-d7831d931bdb.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with lounge furniture and umbrellas near building entrance.",
        "public_id": "019cfde0-08cb-7197-8daf-d7831d931bdb",
        "storage_key": "property/6767906449162945/019cfde0-08cb-7197-8daf-d7831d931bdb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor seating area, featuring comfortable lounge furniture and spacious umbrellas for shade.",
      "link": "false",
      "alt_text": "Outdoor seating area with lounge furniture and umbrellas near building entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yxUJ6qaRLBkBeEpN1cOcmsDFJhcXX1v3yZ5sAUljPwg/119/image.jpg"
    },
    {
      "id": "ec_dda3099fd0f31a5979fd3d96",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-95dd-77ae-96c0-0b91d299d597.webp",
      "image_media": {
        "alt_text": "Community clubhouse entrance with blue doors and outdoor seating.",
        "public_id": "019d4e8c-95dd-77ae-96c0-0b91d299d597",
        "storage_key": "property/6767906449162945/019d4e8c-95dd-77ae-96c0-0b91d299d597.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our beautiful clubhouse, featuring ample seating and umbrellas for outdoor relaxation.",
      "link": "false",
      "alt_text": "Community clubhouse entrance with blue doors and outdoor seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dAM4-LJNDWPKBxA_7fH3FxreZqmoOe_BJixVXgZhVuI/104/image.jpg"
    },
    {
      "id": "ec_131443400c6d79ae573cff54",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-0b61-7021-9bb9-6c2801f7bb0d.webp",
      "image_media": {
        "alt_text": "A wooden boardwalk leads through trees to a gated pool area with lounge chairs.",
        "public_id": "019cfde0-0b61-7021-9bb9-6c2801f7bb0d",
        "storage_key": "property/6767906449162945/019cfde0-0b61-7021-9bb9-6c2801f7bb0d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the serene ambiance of our community with this scenic boardwalk leading to the sparkling pool and relaxing lounge area.",
      "link": "false",
      "alt_text": "A wooden boardwalk leads through trees to a gated pool area with lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qsK5QDaNBzAttk-lr2pu_w-1LhPjuTStIyR1LjDt8RY/119/image.jpg"
    },
    {
      "id": "ec_35eef9072e474ca43da4597e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-9cb5-74cc-bc31-403c0a5f86d7.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and seating areas.",
        "public_id": "019d4e8c-9cb5-74cc-bc31-403c0a5f86d7",
        "storage_key": "property/6767906449162945/019d4e8c-9cb5-74cc-bc31-403c0a5f86d7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Featuring comfortable seating areas and lush landscaping for a tranquil experience.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/I2xYYdXm3ad6jd6pPi5k4xGerOcsObruZKpBO4CENVc/104/image.jpg"
    },
    {
      "id": "ec_4f087c912bbf4e58e23f9d91",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-11f3-75a3-8635-5319007298fb.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas surrounded by lush landscaping.",
        "public_id": "019cfde0-11f3-75a3-8635-5319007298fb",
        "storage_key": "property/6767906449162945/019cfde0-11f3-75a3-8635-5319007298fb.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool, complete with comfortable lounge chairs and ample shade from umbrellas. Perfect for soaking up the sun or unwinding after a long day.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas surrounded by lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7cr84B6lHmGXbQlCnYn_dXMO5IhHgIgqqR578kf6jbM/119/image.jpg"
    },
    {
      "id": "ec_527454fe6b1309af288a64e4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-b37c-75fb-991f-7c018b76651c.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two stainless steel grills, granite countertops, stone accents, and seating by the pool.",
        "public_id": "019d4e8c-b37c-75fb-991f-7c018b76651c",
        "storage_key": "property/6767906449162945/019d4e8c-b37c-75fb-991f-7c018b76651c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community grilling stations, perfect for al fresco dining and social gatherings by the pool.",
      "link": "false",
      "alt_text": "Outdoor grilling area with two stainless steel grills, granite countertops, stone accents, and seating by the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TN3sannlv2iLut5H1bbH45K8SOFJbNbTZotCNzoBpRk/104/image.jpg"
    },
    {
      "id": "ec_aec96376d621e41f545ed4d3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-175f-7039-9408-5f1f5b2fcfbb.webp",
      "image_media": {
        "alt_text": "Tennis and pickleball courts with blue playing surfaces and green surrounds, fenced in.",
        "public_id": "019cfde0-175f-7039-9408-5f1f5b2fcfbb",
        "storage_key": "property/6767906449162945/019cfde0-175f-7039-9408-5f1f5b2fcfbb.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our on-site tennis and pickleball courts, perfect for friendly matches and exercise.",
      "link": "false",
      "alt_text": "Tennis and pickleball courts with blue playing surfaces and green surrounds, fenced in.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/O2enghP0-kSgZOTz2msWtbzfsV9VtDaOUqBFKkeL-2w/119/image.jpg"
    },
    {
      "id": "ec_bf9557bf3ecc7bcdf83bdb89",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-ae11-737a-b0a6-189e039a0797.webp",
      "image_media": {
        "alt_text": "Fenced dog park area with green grass and trees.",
        "public_id": "019d4e8c-ae11-737a-b0a6-189e039a0797",
        "storage_key": "property/6767906449162945/019d4e8c-ae11-737a-b0a6-189e039a0797.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a safe and fun space for your furry friends to play and socialize within the community.",
      "link": "false",
      "alt_text": "Fenced dog park area with green grass and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HhlWHCmg3Q9Cv0HirykIfQWnEpecK8O-Kh6OAh_IF-M/104/image.jpg"
    },
    {
      "id": "ec_614d4b2027f69024f5a58cbb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-1933-7129-ad29-1c114da44b8e.webp",
      "image_media": {
        "alt_text": "Entrance to an apartment with a blue door and screen porch.",
        "public_id": "019cfde0-1933-7129-ad29-1c114da44b8e",
        "storage_key": "property/6767906449162945/019cfde0-1933-7129-ad29-1c114da44b8e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to your new home! This charming apartment features a private entrance with a screened-in porch, perfect for enjoying the outdoors.",
      "link": "false",
      "alt_text": "Entrance to an apartment with a blue door and screen porch.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cbt1hWEuz3tmphySMVjSazds5zg9b2hj6ZhKZNierTI/119/image.jpg"
    },
    {
      "id": "ec_e63fde39482f15ee52bed17f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-25d8-76d9-a56d-d2f3dd67cc21.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, gray accent chairs, coffee table, dining area, and kitchen counter.",
        "public_id": "019d20a9-25d8-76d9-a56d-d2f3dd67cc21",
        "storage_key": "property/6767906449162945/019d20a9-25d8-76d9-a56d-d2f3dd67cc21.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and modern living area featuring a vibrant blue sofa, plush accent chairs, and a stylish coffee table. The space flows into a well-appointed dining area and a sleek kitchen counter with bar stools.",
      "link": "false",
      "alt_text": "Living room with a blue sofa, gray accent chairs, coffee table, dining area, and kitchen counter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WXBKGZe10Wlfl6sWuedJz_ZKKJGsMnYESYutaz1UzUE/118/image.jpg"
    },
    {
      "id": "ec_b2647c30c3c0dfc2e1c88e0d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-1faa-7366-be4b-62432267ae8e.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, two gray armchairs, a TV, and a ceiling fan.",
        "public_id": "019cfde0-1faa-7366-be4b-62432267ae8e",
        "storage_key": "property/6767906449162945/019cfde0-1faa-7366-be4b-62432267ae8e.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a vibrant blue sofa, plush gray armchairs, a modern entertainment center with a flat-screen TV, and a sleek ceiling fan.",
      "link": "false",
      "alt_text": "Living room with a blue sofa, two gray armchairs, a TV, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gN6YLAYQJH513MYu-V7hcobW9BkE6caLsw4byRe8jt4/113/image.jpg"
    },
    {
      "id": "ec_6277408b89c472b0bfbbffd0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-26c7-72c0-bc34-9461b6e11f0f.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with dark gray chairs and a dark wood table.",
        "public_id": "019d20a9-26c7-72c0-bc34-9461b6e11f0f",
        "storage_key": "property/6767906449162945/019d20a9-26c7-72c0-bc34-9461b6e11f0f.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern kitchen and dining area, perfect for entertaining guests or enjoying a quiet meal at home.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with dark gray chairs and a dark wood table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FHet5HjzVI6Ebw4ajby4bR3zfkWTPS-7bxQB1S0XS-Q/118/image.jpg"
    },
    {
      "id": "ec_e830411f5e52934c29f1242f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-2259-75f4-a547-27b2243eefa4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinetry.",
        "public_id": "019cfde0-2259-75f4-a547-27b2243eefa4",
        "storage_key": "property/6767906449162945/019cfde0-2259-75f4-a547-27b2243eefa4.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Apartment",
      "description": "A contemporary kitchen featuring granite countertops, stainless steel appliances, ample white cabinetry, and a sleek backsplash. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KtPHUVae6bQEeZqTWr0vARtfxkzFeZh60zBgi3LXzXY/113/image.jpg"
    },
    {
      "id": "ec_f08e581e97adb37c09d2cfd8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-294d-728d-a331-00040ed4e42f.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser and bed, decorated with dreamcatchers and modern art.",
        "public_id": "019d20a9-294d-728d-a331-00040ed4e42f",
        "storage_key": "property/6767906449162945/019d20a9-294d-728d-a331-00040ed4e42f.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "A stylish bedroom featuring a spacious dresser, a comfortable bed with decorative pillows, and modern wall art. The room is decorated with dreamcatchers and plants, creating a chic and inviting atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a dresser and bed, decorated with dreamcatchers and modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/y9QlNblYUE4NTB51KyDA-rxancz3JqwxMAXR_s7w_3c/118/image.jpg"
    },
    {
      "id": "ec_cd7258c54f3076bf800182df",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-2982-75e9-a9fa-48d4ac8fbe1f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "019cfde0-2982-75e9-a9fa-48d4ac8fbe1f",
        "storage_key": "property/6767906449162945/019cfde0-2982-75e9-a9fa-48d4ac8fbe1f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This bathroom features a stylish vanity with a sleek countertop and undermount sink, a modern toilet, and a bathtub with a clean white enclosure.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NUS1WqFJmPIgk-v-yEIOVVtyNnIf6XFbtw-xW0C-GdE/113/image.jpg"
    },
    {
      "id": "ec_cd21f7dc62218f08222abd0e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-3067-7239-8d97-4cfd9a79cf2f.webp",
      "image_media": {
        "alt_text": "Closet with shelves and pillows",
        "public_id": "019d20a9-3067-7239-8d97-4cfd9a79cf2f",
        "storage_key": "property/6767906449162945/019d20a9-3067-7239-8d97-4cfd9a79cf2f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Organized closet space with shelving and decorative pillows, perfect for storing your belongings.",
      "link": "false",
      "alt_text": "Closet with shelves and pillows",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/9Ad_Xzrniq7B9dQI0RCkl_2654mKWRlIqwDteSQwKqY/118/image.jpg"
    },
    {
      "id": "ec_2902c837d90933de17ea670b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-2a98-728f-a793-297ae8404849.webp",
      "image_media": {
        "alt_text": "A bedroom with a large bed, blue accent wall, and large window.",
        "public_id": "019cfde0-2a98-728f-a793-297ae8404849",
        "storage_key": "property/6767906449162945/019cfde0-2a98-728f-a793-297ae8404849.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Relax in comfort in our spacious bedrooms, designed for ultimate relaxation and style. Each bedroom features a plush king-sized bed and ample natural light.",
      "link": "false",
      "alt_text": "A bedroom with a large bed, blue accent wall, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fmaIwKW9vAGwGcdtn-02Wn7DRbhs-cbFIZUxlGMIe5E/113/image.jpg"
    },
    {
      "id": "ec_2ed42fb19413d389370bdf40",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d20a9-31dc-7055-80c6-c8f0a6541eb5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub.",
        "public_id": "019d20a9-31dc-7055-80c6-c8f0a6541eb5",
        "storage_key": "property/6767906449162945/019d20a9-31dc-7055-80c6-c8f0a6541eb5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our modern bathrooms, featuring a spacious vanity, sleek fixtures, and a relaxing bathtub.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VZCib2G53UvUSGFNE4UDNj6WrsXYx7YWZ5uVBn0nurA/118/image.jpg"
    },
    {
      "id": "ec_3e7d30c53347ad3a75a9f3dd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-3191-75ef-998a-80aa6ace82e9.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and a laundry basket.",
        "public_id": "019cfde0-3191-75ef-998a-80aa6ace82e9",
        "storage_key": "property/6767906449162945/019cfde0-3191-75ef-998a-80aa6ace82e9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and a laundry basket, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "Empty closet with wire shelving and a laundry basket.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/K-pYI8DR3oXhq1CEB_d4m56chG_qsr6wqDySRPi_vik/113/image.jpg"
    },
    {
      "id": "ec_bd43e9967a05c78dfa888524",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-345f-7706-aa57-a537a6861f72.webp",
      "image_media": {
        "alt_text": "Screened-in porch with a table and four chairs, overlooking greenery.",
        "public_id": "019cfde0-345f-7706-aa57-a537a6861f72",
        "storage_key": "property/6767906449162945/019cfde0-345f-7706-aa57-a537a6861f72.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on the private screened-in porch, complete with seating and a table.",
      "link": "false",
      "alt_text": "Screened-in porch with a table and four chairs, overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TVGBbG73lAIahnr9G96FlGo6TAZzo1tr2d4jTQfVkKE/117/image.jpg"
    },
    {
      "id": "ec_da5948ef6cd0bd7d15ef1516",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-34a2-7041-9775-5e9f6ee6c79a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings nestled among trees, adjacent to a busy highway.",
        "public_id": "019cfde0-34a2-7041-9775-5e9f6ee6c79a",
        "storage_key": "property/6767906449162945/019cfde0-34a2-7041-9775-5e9f6ee6c79a.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Discover comfortable living with this aerial perspective showcasing apartment buildings surrounded by lush greenery and conveniently located near a major highway for easy access to the city.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings nestled among trees, adjacent to a busy highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/K3FGy4esR67WvD4CHxLzB1yHZCgK2GHmjBm7vJ7T1n8/102/image.jpg"
    },
    {
      "id": "ec_dfb0922ed4241ce88b227175",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-37d1-73db-84fd-75bc77517e87.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with parking lot in foreground.",
        "public_id": "019cfde0-37d1-73db-84fd-75bc77517e87",
        "storage_key": "property/6767906449162945/019cfde0-37d1-73db-84fd-75bc77517e87.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the apartment building's exterior, showcasing its architecture and the surrounding parking area.",
      "link": "false",
      "alt_text": "Exterior view of the apartment building with parking lot in foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qUHmr4TZCitvIw-1wsNdxGjc8uLXeXK341L8pE_jLaU/102/image.jpg"
    },
    {
      "id": "ec_344a18d5bf39f6ffef9cad2b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-3b1e-74b8-9af0-133d46cc3ccf.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with trees and parking lot",
        "public_id": "019cfde0-3b1e-74b8-9af0-133d46cc3ccf",
        "storage_key": "property/6767906449162945/019cfde0-3b1e-74b8-9af0-133d46cc3ccf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with mature trees and a parking lot in the foreground. Shows the community's lush landscaping and architecture.",
      "link": "false",
      "alt_text": "Apartment building exterior with trees and parking lot",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RgbYEO22grNdIZZyzbbdoqtbluE4bWyEUkDJBInD2DY/119/image.jpg"
    },
    {
      "id": "ec_9945d293f6998285abd58774",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8d-2a4b-727e-8441-581e88a530c6.webp",
      "image_media": {
        "alt_text": "MetroWest Premier Apartments monument sign with palm trees and landscaping.",
        "public_id": "019d4e8d-2a4b-727e-8441-581e88a530c6",
        "storage_key": "property/6767906449162945/019d4e8d-2a4b-727e-8441-581e88a530c6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to MetroWest Premier Apartments, featuring a prominent monument sign with the property name and address, surrounded by lush landscaping and palm trees.",
      "link": "false",
      "alt_text": "MetroWest Premier Apartments monument sign with palm trees and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BXYOBGMkPkQZHjxDhiIHhlm67t36ZTVJqO4XRDrgkqI/102/image.jpg"
    },
    {
      "id": "ec_dd4f1ece2119e45c0a1a0bf5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-3e1b-7329-a57c-fc81b71bc27d.webp",
      "image_media": {
        "alt_text": "Welcome to MetroWest Premier Apartments signage with palm trees and landscaping.",
        "public_id": "019cfde0-3e1b-7329-a57c-fc81b71bc27d",
        "storage_key": "property/6767906449162945/019cfde0-3e1b-7329-a57c-fc81b71bc27d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to MetroWest Premier Apartments. View community details and exterior features.",
      "link": "false",
      "alt_text": "Welcome to MetroWest Premier Apartments signage with palm trees and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/M-0mLTM33tXFQ_lICgczRnKrIY3YoEynSkdFZRcl0NA/119/image.jpg"
    },
    {
      "id": "ec_586d699ca6f98405c681ba7a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-415a-727d-a20a-cec5aac418a5.webp",
      "image_media": {
        "alt_text": "Building entrance with palm trees and golf carts parked nearby.",
        "public_id": "019cfde0-415a-727d-a20a-cec5aac418a5",
        "storage_key": "property/6767906449162945/019cfde0-415a-727d-a20a-cec5aac418a5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to our community's building entrance, featuring beautiful landscaping and convenient golf cart parking.",
      "link": "false",
      "alt_text": "Building entrance with palm trees and golf carts parked nearby.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mxdQ2_wuElfh1uPeVPpoPJWmM76vDJPrN-4h_NE_oJw/102/image.jpg"
    },
    {
      "id": "ec_e0ec86b19d6cec1b49545b27",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-46be-70de-a044-22137d8c9e47.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and palm trees.",
        "public_id": "019cfde0-46be-70de-a044-22137d8c9e47",
        "storage_key": "property/6767906449162945/019cfde0-46be-70de-a044-22137d8c9e47.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds surround these apartment buildings, offering a serene and welcoming living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with lush green lawns and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/YdAs3rbAAidrk6uYjj_7KMg5MIT79Ai2YTeT1UI2VXc/119/image.jpg"
    },
    {
      "id": "ec_f47250c5be4a53d4c07c8d71",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-d460-77c4-a7d3-44514e2132c5.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and a highway.",
        "public_id": "019d4e8c-d460-77c4-a7d3-44514e2132c5",
        "storage_key": "property/6767906449162945/019d4e8c-d460-77c4-a7d3-44514e2132c5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "An aerial view showcases a suburban neighborhood with apartment buildings nestled among lush trees, adjacent to a busy highway. The city skyline is visible in the distance.",
      "link": "false",
      "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and a highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Kic8zTFlMldIGYQiz-tCi5reOj6TC72VvtoLJVa9Bd4/102/image.jpg"
    },
    {
      "id": "ec_08f1db7dafc32984e867ed96",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-4a8a-74cc-abe6-bd640a8c5e10.webp",
      "image_media": {
        "alt_text": "Tennis and pickleball courts with fencing and surrounding trees.",
        "public_id": "019cfde0-4a8a-74cc-abe6-bd640a8c5e10",
        "storage_key": "property/6767906449162945/019cfde0-4a8a-74cc-abe6-bd640a8c5e10.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle on our lighted tennis and pickleball courts, perfect for friendly matches and exercise.",
      "link": "false",
      "alt_text": "Tennis and pickleball courts with fencing and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/r_9mSwzK031Ewex9A3hR4u1PLlUWyOWBpoWXGCnVo1E/119/image.jpg"
    },
    {
      "id": "ec_c304d2eddfb23a8f712ff165",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-ecaa-727e-8854-1994a7457964.webp",
      "image_media": {
        "alt_text": "City West Apartment Homes leasing center entrance with balloons and landscaping.",
        "public_id": "019d4e8c-ecaa-727e-8854-1994a7457964",
        "storage_key": "property/6767906449162945/019d4e8c-ecaa-727e-8854-1994a7457964.webp",
        "width": 2048,
        "height": 1192
      },
      "title": "Community",
      "description": "Welcome to City West Apartment Homes! Visit our leasing center for tours and information about our community.",
      "link": "false",
      "alt_text": "City West Apartment Homes leasing center entrance with balloons and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZSZQJGMPtq97oxNmmn2UXWTiY6x4eeLI8lZvxFJiWeM/104/image.jpg"
    },
    {
      "id": "ec_1763e76f751372b6baefb836",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-edf8-702e-bd34-8f0d804d7379.webp",
      "image_media": {
        "alt_text": "Property map showing \"Town and Country at Kirkman\" and highlighted area labeled \"R3B\" and \"Copper Terrace Apts.\"",
        "public_id": "019d4e8c-edf8-702e-bd34-8f0d804d7379",
        "storage_key": "property/6767906449162945/019d4e8c-edf8-702e-bd34-8f0d804d7379.webp",
        "width": 1256,
        "height": 888
      },
      "title": "Other",
      "description": "Detailed map illustrating property lines and parcel information, including \"Town and Country at Kirkman\" and the \"R3B\" zone for \"Copper Terrace Apts.\"",
      "link": "false",
      "alt_text": "Property map showing \"Town and Country at Kirkman\" and highlighted area labeled \"R3B\" and \"Copper Terrace Apts.\"",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WbnNGO3Gwk9ZLSgskZ9D-wwcEN5AK9HV2SyVrp1aHd8/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_c9af89afc69c841f5149c479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "poi_name": "Eagles Nest Elementary",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_2f5a925b9ff0ec7d7b0f60de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "poi_name": "Florida Virtual Middle School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_7a765f71ed9a29ad624ddad5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "poi_name": "Florida Virtual High School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_1149ac2a1ea5dffd1538d8e2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "5",
      "name": "false",
      "text": "Living in Citywest was a great first apartment experience. The apartments have a very good home feel to it. My guest are always saying they feel like home when they're over. The staff here are very friendly and cooperative. In my opinion I've been here for almost a year and enjoyed it !",
      "date": "false",
      "title": "Great first apartment"
    },
    {
      "id": "ec_78318705a96083cb31c6eca5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "5",
      "name": "false",
      "text": "the people here are great always helping the residents there like family here understand situation at  hand I love living here it can be touch sometimes but we always seems to get through it.....",
      "date": "false",
      "title": "City West residential"
    },
    {
      "id": "ec_6324ef1981e3fee12aa37737",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "5",
      "name": "false",
      "text": "I have been living here for a few ears now. The recent management which I think took over a few months ago has been really terrific. They are all so nice and pleasure to deal with. They have done a really nice job with the gym and added a locker system for all my amazon orders :)\n\nI would highly recommend!",
      "date": "false",
      "title": "Love it!!!!!!!!!!"
    },
    {
      "id": "ec_c4ff3f00803c1da08c128b01",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "5",
      "name": "false",
      "text": "i just moved in and i had the most amazing experience \napartments are beautiful and service is great !!!",
      "date": "false",
      "title": "Worth every penny "
    },
    {
      "id": "ec_084d5c5bcdc2620e966fb7e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "5",
      "name": "false",
      "text": "I just moved into the two bedroom loft & I love it. I use the upstairs as my office since I work from home. So far my neighbors are quiet. I'm happy with the location to the 408. ",
      "date": "false",
      "title": "I Like My New Place"
    },
    {
      "id": "ec_f3db1d90d2565da4fc5d2767",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "4",
      "name": "false",
      "text": "Definitely a good place to live! I haven't had any issues so far, maintenance team seems great unlike my last place I stayed. The office was helpful and made my move in a smooth transition!",
      "date": "false",
      "title": "Good place to live! "
    },
    {
      "id": "ec_5248ae36241e3a00116fd0a0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "5",
      "name": "false",
      "text": "Office and maintenance are friendly and very responsive. \n",
      "date": "false",
      "title": "Friendly "
    },
    {
      "id": "ec_e12ccbfd2484cfdb4a295a8d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "rating": "5",
      "name": "false",
      "text": "Just renewed my lease, the staff is really helpful, they listen and address any issue really fast. Amenities well kept up and pet friendly. Definitely recommend this place to anyone plus they provide referrals bonus to residents when you recommend someone.  ",
      "date": "false",
      "title": "My 1st Renewal! "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_15cc157d4382a9e70dada0e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/9q4l6w?source=180"
    },
    {
      "id": "ec_b1ee090ff46d73460183c3db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "1801 Metrowest - Apartments.com",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/1c5o0o?source=180"
    },
    {
      "id": "ec_cb013aac8214b0ea919cf1d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6f02-70e7-9d5b-ca2f6d9268f5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room and dining area with blue sofa, grey armchair, and bar seating.",
        "public_id": "019cfde0-6f02-70e7-9d5b-ca2f6d9268f5",
        "storage_key": "property/6767906449162945/019cfde0-6f02-70e7-9d5b-ca2f6d9268f5.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 2BA - 1015SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=o2ejGQaFYkX"
    },
    {
      "id": "ec_fcc9d05878bdccab22860070",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6ee8-7782-b0f8-e49f37c51346.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious apartment complex lobby with a reception desk, lounge seating, and gym equipment visible through glass doors.",
        "public_id": "019cfde0-6ee8-7782-b0f8-e49f37c51346",
        "storage_key": "property/6767906449162945/019cfde0-6ee8-7782-b0f8-e49f37c51346.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UV1cMM2K1Tk"
    },
    {
      "id": "ec_ae341ef0a70d216d9ee5b384",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6e8e-72eb-9553-3f655c801d3d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with treadmills, dumbbells, medicine balls, and exercise bikes.",
        "public_id": "019cfde0-6e8e-72eb-9553-3f655c801d3d",
        "storage_key": "property/6767906449162945/019cfde0-6e8e-72eb-9553-3f655c801d3d.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DCkTrAJhJtx"
    },
    {
      "id": "ec_320eace249a155e70c3e383d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162945",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6e55-761f-8ae6-d49ad34e03e6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with vaulted ceilings, fireplace, and view of kitchen.",
        "public_id": "019cfde0-6e55-761f-8ae6-d49ad34e03e6",
        "storage_key": "property/6767906449162945/019cfde0-6e55-761f-8ae6-d49ad34e03e6.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 2BA - 1015SF - B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rmMJU7maN9q"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_text_field",
      "type": "STRING",
      "value": "Gallery | Apartments in Orlando, NC"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    }
  ],
  "custom_text_field": "Gallery | Apartments in Orlando, NC",
  "custom_rollout_phase": "Phase 1"
};

export const generatedAt = '2026-10-05T18:31:18.834Z';
